<template>
  <div
    :class="classes"
    class="tdx-ticker-logo"
  >
    <img
      :src="src"
      :alt="alt"
      @error="setAltImg"
    >
  </div>
</template>

<script>
import { sizeValidator, defaultSize } from '@/lib/utils'

export default {
  name: 'TdxTickerLogo',
  props: {
    src: {
      type: String,
      default: '/img/balance/coinDefaultIcon.png',
    },
    alt: {
      type: String,
      default: '',
    },
    size: {
      validator: sizeValidator,
      default: defaultSize,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    transparentBorder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      return {
        // sizes
        'tdx-ticker-logo--xs': this.size === 'xs',
        'tdx-ticker-logo--s': this.size === 's',
        'tdx-ticker-logo--m': this.size === 'm',
        'tdx-ticker-logo--l': this.size === 'l',
        'tdx-ticker-logo--xl': this.size === 'xl',

        // options
        'tdx-ticker-logo--active': this.isActive,
        'tdx-ticker-logo--transparent-border': this.transparentBorder && !this.isActive,
      }
    },
  },
  methods: {
    setAltImg (event) {
      event.target.src = '/img/balance/coinDefaultIcon.png'
    },
  },
}
</script>

<style lang="scss" scoped>
.tdx-ticker-logo {
  $sizeMobile: 20px;
  $tickerSize: (
    xs: 20px,
    s: 28px,
    m: 32px,
    l: 40px,
    xl: 44px,
  );
  display: flex;
  align-items: center;
  justify-content: center;
  width: toRem($sizeMobile);
  height: toRem($sizeMobile);
  max-width: toRem($sizeMobile);
  max-height: toRem($sizeMobile);
  min-width: toRem($sizeMobile);
  min-height: toRem($sizeMobile);
  //border-radius: 50%;
  //border: 1px solid color(color-05);

  &--transparent-border {
    border-color: transparent;
  }

  &--active {
    border-color: color(main);
  }

  @include bp(s) {
    @each $size, $value in $tickerSize {
      &--#{$size} {
        width: toRem($value);
        height: toRem($value);
        max-width: toRem($value);
        max-height: toRem($value);
        min-width: toRem($value);
        min-height: toRem($value);
      }
    }
  }

  img {
    max-height: 100%;
    max-width: 100%;
    //border-radius: 999px;
  }
}
</style>
